import { useState } from 'react';
import HERO_IMAGES from '../heroImages';
import SEO from '../components/SEO/SEO';
import {
  Mail, Phone, MapPin, MessageSquare, Send,
  CheckCircle2, Clock, AlertCircle,
} from 'lucide-react';
import './ContactPage.css';

const orgCategories = [
  'Technology', 'Education', 'Healthcare', 'Finance & Banking',
  'E-Commerce & Retail', 'Logistics & Supply Chain', 'Real Estate',
  'Media & Entertainment', 'Manufacturing', 'Government / NGO', 'Others',
];

const LinkedInIcon = () => (
  <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);
const WhatsAppIcon = () => (
  <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);
const GitHubIcon = () => (
  <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
  </svg>
);

export default function ContactPage() {
  const [form, setForm] = useState({
    name: '',
    organization: '',
    orgCategory: '',
    otherCategory: '',
    description: '',
    email: '',
    contact: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // ─── OTP verification state ───
  const [otpToken, setOtpToken] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpSending, setOtpSending] = useState(false);
  const [otpError, setOtpError] = useState('');
  const [otpVerifiedEmail, setOtpVerifiedEmail] = useState('');

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSendOtp = async () => {
    setOtpError('');
    if (!emailRegex.test(form.email)) {
      setOtpError('Enter a valid email address first.');
      return;
    }
    setOtpSending(true);
    try {
      const res = await fetch('/api/send-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: form.email, purpose: 'contact' }),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.error || 'Failed to send verification code.');
      }
      setOtpToken(data.otpToken);
      setOtpSent(true);
      setOtpVerified(false);
      setOtpCode('');
    } catch (err) {
      setOtpError(err.message || 'Something went wrong sending the code.');
    } finally {
      setOtpSending(false);
    }
  };

  const handleVerifyOtp = () => {
    setOtpError('');
    if (!otpCode || otpCode.length !== 6) {
      setOtpError('Enter the 6-digit code from your email.');
      return;
    }
    // Actual verification happens server-side on submit; this just locks in
    // the code + email pair the user confirmed client-side so we don't
    // resend it unnecessarily.
    setOtpVerified(true);
    setOtpVerifiedEmail(form.email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (error) setError('');
    if (name === 'email') {
      setOtpSent(false);
      setOtpVerified(false);
      setOtpToken('');
      setOtpCode('');
      setOtpError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!otpVerified || otpVerifiedEmail !== form.email) {
      setError('Please verify your email with the code sent to it before submitting.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, otp: otpCode, otpToken }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Failed to send message. Please try again.');
      }

      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again or email us directly.');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setForm({
      name: '',
      organization: '',
      orgCategory: '',
      otherCategory: '',
      description: '',
      email: '',
      contact: '',
    });
    setSubmitted(false);
    setError('');
    setOtpToken('');
    setOtpCode('');
    setOtpSent(false);
    setOtpVerified(false);
    setOtpError('');
    setOtpVerifiedEmail('');
  };

  return (
    <main className="contact-page">
      <SEO
        title="Contact Us — Start Your Next Project"
        description="Get in touch with ExploitEye for a free consultation on your web, app, automation, marketing, or cyber security project. We respond within 24 hours."
        path="/contact"
        keywords="contact ExploitEye, hire web developers India, request quote software development"
      />
      <section className="page-hero" style={{ backgroundImage: `url(${HERO_IMAGES.contact})` }}>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <span className="section-label">Let's Talk</span>
          <h1>
            Start Your
            <br />
            <span className="gradient-text">Next Project</span>
          </h1>
          <p>
            Tell us about your idea. We'll respond within 24 hours with a free consultation booking.
          </p>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            {/* Left info panel */}
            <div className="contact-info">
              <h2>Get in Touch</h2>
              <p>
                Whether you have a fully formed idea or just a vague concept — we're happy to talk.
                No hard sell, just honest advice.
              </p>
              <div className="contact-info__items">
                <a href="mailto:info@exploiteye.in" className="contact-info__item">
                  <div className="contact-info__icon">
                    <Mail size={18} />
                  </div>
                  <div>
                    <strong>Email Us</strong>
                    <span>info@exploiteye.in</span>
                  </div>
                </a>
                <a href="tel:+918940551811" className="contact-info__item">
                  <div className="contact-info__icon">
                    <Phone size={18} />
                  </div>
                  <div>
                    <strong>Call Us</strong>
                    <span>+91 89405 51811</span>
                  </div>
                </a>
                <a
                  href="https://wa.me/918940551811"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-info__item"
                >
                  <div className="contact-info__icon contact-info__icon--whatsapp">
                    <MessageSquare size={18} />
                  </div>
                  <div>
                    <strong>WhatsApp</strong>
                    <span>Chat with us</span>
                  </div>
                </a>
              </div>
              <div className="contact-socials">
                <a
                  href="https://linkedin.com/company/exploiteye"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-social"
                  aria-label="LinkedIn"
                >
                  <LinkedInIcon />
                </a>
                <a
                  href="https://wa.me/918940551811"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-social"
                  aria-label="WhatsApp"
                >
                  <WhatsAppIcon />
                </a>
                <a
                  href="https://github.com/exploiteye"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-social"
                  aria-label="GitHub"
                >
                  <GitHubIcon />
                </a>
              </div>

              {/* Location Card */}
              <div className="location-card">
                <div className="location-card__map">
                  <iframe
                    title="ExploitEye Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d497511.2319634955!2d79.82734679999999!3d13.0478022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sChennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1700000000000"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    allowFullScreen
                  />
                </div>
                <div className="location-card__body">
                  <h4>Our Office</h4>
                  <div className="location-detail">
                    <MapPin size={14} />
                    <span>Chennai, Tamil Nadu, India — 600 001</span>
                  </div>
                  <div className="location-hours">
                    <div className="location-hours__title">Working Hours</div>
                    <div className="location-hours__row">
                      <span>Mon – Fri</span>
                      <span>9:00 AM – 6:30 PM</span>
                    </div>
                    <div className="location-hours__row">
                      <span>Saturday</span>
                      <span>10:00 AM – 2:00 PM</span>
                    </div>
                    <div className="location-hours__row">
                      <span>Sunday</span>
                      <span style={{ color: 'var(--accent-rose)' }}>Closed</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right form */}
            <div className="contact-form-card">
              {submitted ? (
                <div className="contact-success">
                  <CheckCircle2 size={52} />
                  <h3>Message Received!</h3>
                  <p>
                    Thank you for reaching out. Our team will respond within 24 hours with a
                    consultation booking link. Please check your email for confirmation.
                  </p>
                  <button type="button" className="btn-ghost" onClick={resetForm}>
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="contact-form-row">
                    <div className="form-group">
                      <label htmlFor="name">Your Name *</label>
                      <input
                        id="name"
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="Your full name"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="organization">Organisation</label>
                      <input
                        id="organization"
                        type="text"
                        name="organization"
                        value={form.organization}
                        onChange={handleChange}
                        placeholder="Your Company"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="orgCategory">Industry</label>
                    <select
                      id="orgCategory"
                      name="orgCategory"
                      value={form.orgCategory}
                      onChange={handleChange}
                    >
                      <option value="">Select your industry</option>
                      {orgCategories.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  </div>

                  {form.orgCategory === 'Others' && (
                    <div className="form-group">
                      <label htmlFor="otherCategory">Please specify</label>
                      <input
                        id="otherCategory"
                        type="text"
                        name="otherCategory"
                        value={form.otherCategory}
                        onChange={handleChange}
                        placeholder="Your industry"
                      />
                    </div>
                  )}

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      <input
                        id="email"
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="you@company.com"
                        required
                        style={{ flex: '1 1 260px', minWidth: 0 }}
                      />
                      <button
                        type="button"
                        className="btn-ghost"
                        onClick={handleSendOtp}
                        disabled={otpSending || !form.email}
                        style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                      >
                        {otpSending ? 'Sending...' : otpSent ? 'Resend Code' : 'Verify Email'}
                      </button>
                    </div>
                  </div>

                  <div className="contact-form-row">
                    <div className="form-group">
                      <label htmlFor="contact">Phone Number</label>
                      <input
                        id="contact"
                        type="tel"
                        name="contact"
                        value={form.contact}
                        onChange={handleChange}
                        placeholder="+91 98765 43210"
                      />
                    </div>
                  </div>

                  {otpSent && !otpVerified && (
                    <div className="form-group">
                      <label htmlFor="otpCode">
                        Enter the 6-digit code sent to {form.email}
                      </label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input
                          id="otpCode"
                          type="text"
                          inputMode="numeric"
                          maxLength={6}
                          value={otpCode}
                          onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ''))}
                          placeholder="123456"
                          style={{ flex: 1, letterSpacing: '4px' }}
                        />
                        <button
                          type="button"
                          className="btn-primary"
                          onClick={handleVerifyOtp}
                          style={{ whiteSpace: 'nowrap' }}
                        >
                          Confirm Code
                        </button>
                      </div>
                    </div>
                  )}

                  {otpVerified && otpVerifiedEmail === form.email && (
                    <div className="form-group" style={{ color: 'var(--accent-emerald, #059669)', fontSize: '13px' }}>
                      <CheckCircle2 size={14} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
                      Email verified
                    </div>
                  )}

                  {otpError && (
                    <div className="form-error">
                      <AlertCircle size={16} />
                      <span>{otpError}</span>
                    </div>
                  )}

                  <div className="form-group">
                    <label htmlFor="description">Project Description *</label>
                    <textarea
                      id="description"
                      name="description"
                      value={form.description}
                      onChange={handleChange}
                      placeholder="Tell us about your project, goals, and timeline..."
                      rows={5}
                      required
                    />
                  </div>

                  {error && (
                    <div className="form-error">
                      <AlertCircle size={16} />
                      <span>{error}</span>
                    </div>
                  )}

                  <div className="contact-submit">
                    <button
                      type="submit"
                      className="btn-primary"
                      disabled={loading || !otpVerified || otpVerifiedEmail !== form.email}
                    >
                      {loading ? (
                        <>
                          <span className="spinner" /> Sending...
                        </>
                      ) : (
                        <>
                          Send Message <Send size={15} />
                        </>
                      )}
                    </button>
                    <span className="contact-submit-note">
                      <Clock size={12} /> Response within 24 hours
                    </span>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}